const CommunityContainer = {
  width: '350px',
  paddingTop: '30px',
  zIndex: 10
};

export const communityStyles = {
  CommunityContainer
};
